export interface UserDetailsResponse {
  name: string;
  document_number: string;
  six_digits_document?: string;
  masked_email?: string | null;
  /** Ex.: "(**)987**-**21". Vem null quando o cadastro não tem telefone (versões antigas podiam mandar "" ou espaços). */
  masked_phone?: string | null;
  /** CORE-1025 (proposta do api-core): false quando o telefone é nulo, "" ou só espaços. */
  has_phone?: boolean;
  has_email?: boolean;
}

export interface SendCodeRequest {
  document: string;
  codeType: number;
}

export interface ValidateCodeRequest {
  document: string;
  code: string;
  codeType: number;
}

export interface ValidateCodeResponse {
  person_id: string;
  user_id: string;
  token: string;
  roles: string[];
  name: string;
  username: string;
  /** `m` | `f`. Vem vazio quando o cadastro ainda não tem género definido. */
  gender?: string;
}

/** Corpo do PUT /v2/users/me/mobile-phone (CORE-1025). */
export interface SaveMobilePhoneRequest {
  mobile_phone: string;
}

/** Chaves de erro (400) do PUT /v2/users/me/mobile-phone. */
export const MOBILE_PHONE_ERROR_KEYS = {
  INVALID: 'INVALID_MOBILE_PHONE',
  ALREADY_REGISTERED: 'MOBILE_PHONE_ALREADY_REGISTERED'
} as const;
